import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tests',
  template: require('./tests.component.html'),
  // styles: [require('./tests.component.css')]
  styles: [require('./tests.component.css').toString()]
})
export class TestsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  tabSwitch(evt, tabName) {
    let i, x, tablinks;
    x = document.getElementsByClassName('tab');
    for (i = 0; i < x.length; i++) {
      x[i].style.display = 'none';
    }
    tablinks = document.getElementsByClassName('tabLink');
    for (i = 0; i < x.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' tabColor', '');
    }
    document.getElementById(tabName).style.display = 'block';
    evt.currentTarget.className += ' tabColor';
  }


}
